import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root',
})
export class CandidatesService {
  httpOptions;
  httpBoday = '';
  public valueIDForCandidateData = 'AA';
  rid;
  jid;
  CandidateOnboardingValue = 1;

  constructor(private http: HttpClient) { }

  addSchedule(scheduleData) {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Schedule.add, scheduleData, this.httpOptions);
  }

  addInviteSchedule(scheduleData) {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Schedule.invite, scheduleData, this.httpOptions);
  }

  sendEEO(eeoData) {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.EEO.update, eeoData, this.httpOptions);
  }

  getEEODetail(): Observable<any> {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.EEO.details + `/${rid}`, this.httpOptions);
  }

  sendTask(taskdata) {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Tasks.send+`/${rid}/${jid}`, taskdata, this.httpOptions);
  }

  sendComment(commnentData) {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Comments.send, commnentData, this.httpOptions);
  }

  sendText(textdata) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Texts.send, textdata, this.httpOptions);
  }

  getBuzzWords(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Texts.buzzWords, this.httpOptions);
  }

  getHashTags(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Texts.hashTags, this.httpOptions);
  }

  addBuzzWords(buzzWordsBody): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Texts.buzzWords, buzzWordsBody, this.httpOptions);
  }

  deleteBuzzWords(SRID): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.Texts.buzzWords + `/${SRID}`, '', this.httpOptions);
  }

  addHashTags(hashTagsBody): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Texts.hashTags, hashTagsBody, this.httpOptions);
  }

  deleteHashTags(SRID): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.Texts.hashTags + `/${SRID}`, '', this.httpOptions);
  }

  sendShare(shareData) {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Shares.send, shareData, this.httpOptions);
  }

  sendEmail(emailData) {
    const token = localStorage.getItem('token');

    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Emails.send, emailData, this.httpOptions);
  }

  sendQuestion(questionBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.questions, questionBody, this.httpOptions);
  }

  getSchedule() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Schedule.all, this.httpOptions);
  }

  getEmailHistory() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Emails.all + `/${rid}`, this.httpOptions);
  }

  getShareHistory(): Observable<any> {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Shares.history + `/${rid}`, this.httpOptions);
  }

  getCandidateTimelineData(jid) {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.timeline + `/${rid}/${jid}`, this.httpOptions);
  }

  getTask(): Observable<any> {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Tasks.all+`/${rid}/${jid}`, this.httpOptions);
  }

  getCandidateTaskData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.Tasks.tasks + `/${rid}/${jid}`,
      this.httpOptions
    );
  }

  getCandidateData() {
    const token = localStorage.getItem('token');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.all + `?days=-5000&canview=${this.valueIDForCandidateData}`,
      this.httpOptions
    );
  }

  getCandidateList(id) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.all + `?days=-5000&canview=${id}`,
      this.httpOptions
    );
  }

  getAllCandidates() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.all + `?days=-5000&canview=AA`,
      this.httpOptions
    );
  }

  getMovedCandidates() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.all + `?days=-30&canview=MV`,
      this.httpOptions
    );
  }

  setCandidateListCatogory(value) {
    this.valueIDForCandidateData = value;
  }

  getCandidateBasicInfo(rid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.basic + `/${rid}`, this.httpOptions);
  }

  private requestOptions() {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return httpOptions;
  }

  getCandidateProfile(rid) {
    return this.http.get<any>(ApiEndPoint.Candidates.profile + `/${rid}`, this.requestOptions());
  }

  getAllIntegrations(rid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.thirdParties + `/${rid}`,
      this.httpOptions
    );
  }

  getJobIdAndCandiadte_JobId(rid, jid) {
    this.rid = rid;
    this.jid = jid;
  }

  getCandidateScheduleData(rid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Schedule.history + `/${rid}`, this.httpOptions);
  }

  getCandidateCommentData(): Observable<any> {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    //const r_rid = 9385342;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Comments.all + `/${rid}`, this.httpOptions);
  }

  getCandidateTextData(): Observable<any> {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Texts.text + `/${rid}`, this.httpOptions);
  }

  getCandidateEmailData(): Observable<any> {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Emails.all + `/${rid}`, this.httpOptions);
  }

  getCandidateShareData(): Observable<any> {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.Shares.all + `/${rid}/${jid}`,
      this.httpOptions
    );
  }

  getCandidateColorData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.colors, this.httpOptions);
  }

  getactivityDayFilterData() {
    const token = localStorage.getItem('token');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.FilterBy.activityDays, this.httpOptions);
  }

  getCandidateJobAppliedData() {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.appliedJobs + `/${rid}`, this.httpOptions);
  }

  getCandidateJobApplied(rid: string) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.appliedJobs + `/${rid}`, this.httpOptions);
  }

  getPowerUserFilterData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.powerUsers, this.httpOptions);
  }

  getRecruitFlowFilterData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.workflows, this.httpOptions);
  }

  getEtancityData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.ethnicity, this.httpOptions);
  }

  getGenderData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.gender, this.httpOptions);
  }

  getSourceData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.EEO.source, this.httpOptions);
  }

  getvetsData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.EEO.veteran, this.httpOptions);
  }

  getDisposition() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.EEO.Disposition.all, this.httpOptions);
  }

  getDispositionForJob() {
    const token = localStorage.getItem('token');
    // const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Candidates.EEO.Disposition.dispositions + `/${rid}`,
      this.httpOptions
    );
  }

  getQuestionData(jid): Observable<any> {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    // const jid = localStorage.getItem('jid');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.questions + `/${rid}/${jid}`, this.httpOptions);
  }

  getJobQuestions(jid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.questions + `/${jid}`, this.httpOptions);
  }

  getCandidateDoNotHireData(rid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.doNotHire + `/${rid}`, this.httpOptions);
  }

  updateDoNotHireStatus(rid, doNotHireBody): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.doNotHire + `/${rid}`, doNotHireBody, this.httpOptions);
  }

  getCandidateDuplicateProfileData(rid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.duplicated + `/${rid}`, this.httpOptions);
  }

  updateDuplicateProfileStatus(rid, doNotHireBody): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.duplicated + `/${rid}`, doNotHireBody, this.httpOptions);
  }

  getSkillTag(rid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.SkillTags.all + `/${rid}`, this.httpOptions);
  }

  deleteSkillTag(skillTag): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.SkillTags.delete + `/${skillTag.RID}/${skillTag.qnjid}/${skillTag.NID}`, '', this.httpOptions);
  }

  createQuickNote(quickNoteData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.SkillTags.add, quickNoteData, this.httpOptions);
  }

  updateQuickNote(quickNoteData, NID): Observable<any> {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.SkillTags.update + `/${rid}/${NID}`, quickNoteData, this.httpOptions);
  }

  getSkillLabels() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.SkillTags.labels, this.httpOptions);
  }

  assignCandidateJob(jobData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.assign, jobData, this.httpOptions);
  }

  moveCandidateWorkflow(jobData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.move, jobData, this.httpOptions);
  }

  unassignCandidateJob(unassignJobData): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.unassign, unassignJobData, this.httpOptions);
  }

  // Candidate-OnBoarding Api
  getCandidate_OnboardingData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Onboarding.all + `/${this.CandidateOnboardingValue}`,
      this.httpOptions
    );
  }

  getCandidateOnboardingDataValue(value) {
    this.CandidateOnboardingValue = value;
  }

  getCandidateScorecard(jid) {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    //  to test
    // return this.http.get<any>(ApiEndPoint.Candidates.scorecard + `/85315/241630`, this.httpOptions);
    // return this.http.get<any>(ApiEndPoint.Jobs.scorecard + `/85315/241630`, this.httpOptions);
    return this.http.get<any>(ApiEndPoint.Jobs.scorecard + `/${rid}/${jid}`, this.httpOptions);
  }

  getScorecardDetail(SGID): Observable<any> {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Scorecards.all + `/${SGID}`, this.httpOptions);
  }

  updateCandidateScorecard(scorecardBodyData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.scorecard, scorecardBodyData, this.httpOptions);
  }

  getCandidateApplication(rid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.application + `/${rid}`, this.httpOptions);
  }

  getJobs(status) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.all +
      `?status=${status}&recordsPerPage=1000&page=1`,
      this.httpOptions
    );
  }

  getCandidateDetail() {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.details + `/${rid}`, this.httpOptions);
  }

  editCandidate(candidateData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Candidates.update, candidateData, this.httpOptions);
  }

  getResume(rid, jid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Resume.text + `/${rid}/${jid}`, this.httpOptions);
  }

  getFileResume(rid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Resume.file + `/${rid}`, this.httpOptions);
  }

  getPopularSources(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.sources, this.httpOptions);
  }

  getUploadedFiles(rid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Uploaded.all + `/${rid}`, this.httpOptions);
  }

  uploadResumeFile(resumeData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.upload, resumeData, this.httpOptions);
  }

  updateUploadedResume(resumeData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Resume.update, resumeData, this.httpOptions);
  }

  candidateUploadFile(fileData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Uploaded.add, fileData, this.httpOptions);
  }

  addCandidate(candidateData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.add, candidateData, this.httpOptions);
  }

  addCandidateAsResumeFile(resumeFileBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.insert, resumeFileBody, this.httpOptions);
  }

  getReference(rid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Reference.all + `/${rid}`, this.httpOptions);
  }

  getCandidateReferenceCheck(rid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Reference.check + `/${rid}`, this.httpOptions);
  }

  // Best Match in Candidate table
  getBestMatch(view) {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.bestMatches + `/${jid}/${view}`, this.httpOptions);
  }

  // Candidate Job History 
  getCandidateJobHistory(jid) {
    const token = localStorage.getItem('token');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.history + `/${rid}/${jid}`, this.httpOptions);
  }

  updateResendPendingReferences(pendingReferenceBody): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.Reference.resend, pendingReferenceBody, this.httpOptions);
  }

  getHireInformation(rid, jid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.hireInfo + `/${rid}/${jid}`, this.httpOptions);
  }

  getHireCustomFields() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.customFields, this.httpOptions);
  }

  updateHireInformation(hireInformationBody): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Candidates.hireInfo, hireInformationBody, this.httpOptions);
  }

  getCandidateBackground(rid, jid) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    // https://devtheone.pereless.com:8443/v1/index.cfm/getbackground/8676615/7143747
    return this.http.get<any>(ApiEndPoint.Candidates.background + `/${rid}/${jid}`, this.httpOptions);
    // return this.http.get<any>('https://devtheone.pereless.com:8443/v1/index.cfm/getbackground/8676615/7143747', this.httpOptions);
  }

  getCommunication() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const rid = localStorage.getItem('rid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Candidates.Communication.get + `/${rid}/${jid}`, this.httpOptions);
  }

  isEmailDuplicated($request): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    // debounce
    return timer(1000)
      .pipe(
        switchMap(() => {
          return this.http.post<any>(ApiEndPoint.Candidates.valid, 
                                      $request,
                                      httpOptions); 
        })
      );
  }

  getIntegrations(): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    return this.http.get<any>(ApiEndPoint.Integrations.all+`?vendorid=6&type=background`, httpOptions); 
  }

  orderBackgroundCheck(request: any): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    return this.http.post<any>(ApiEndPoint.Integrations.order, request, httpOptions); 
  }

  deletebackgroundCheckOrder(rid: string) {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    console.log('delete background check order => ', ApiEndPoint.Integrations.order + `?rid=${rid}`);
    return this.http.delete<any>(ApiEndPoint.Integrations.order + `?rid=${rid}`, httpOptions); 
  }

  getBackgroundOrder(rid, jid): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    console.log("request orders: ", ApiEndPoint.Integrations.orders + `?rid=${rid}&jid=${jid}`);
    return this.http.get<any>(
      ApiEndPoint.Integrations.orders + `?rid=${rid}&jid=${jid}`,
      httpOptions
    );

    // return this.http.get<any>(
    //   ApiEndPoint.Integrations.orders + `?rid=${940416}&jid=${267912}`,
    //   httpOptions
    // );
  }

}
